import {cdnImage} from '@/util/cdnImage';
import {MUIButton, MUIContainer} from '@/components/MUI-Components';
import {WEARABLE_APP_DEVELOPMENT} from '@/util/metaData/mobile';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import dynamic from 'next/dynamic';
import PageHead from '@/components/PageHead';
import React from 'react';

// ─── getStaticProps ─────────────────────────────────────────────────────────
export const getStaticProps = async () => {
    const {
        fitnessTemButtonData,
        fitnessTemCheckPoint,
        mobileApplicationBannerBottom,
        nordicStringCheckPoint,
        nordicStrongButtonData,
        wellPopButtonData,
        wellPopCheckpoint
    } = await import('@/util/contents/mobile-app-data');

    const {
        wearableAppBannerPoint,
        wearableAppFAQ,
        wearableAppMobileProcess,
        wearableAppServices,
        wearableAppTechnologyData,
        wearableAppUseCase,
        wearableChooseBody,
        wearableChooseContent,
        wearableDecodingData,
        wearableDeviceBuild,
        wearableEmergingData,
        wearableKeyFeature,
        wearablePricingData
    } = await import('@/util/contents/wearable-app');

    const {onDemandIndustryData} = await import('@/util/contents/on-demand-data');

    return {
        props: {
            fitnessTemButtonData,
            fitnessTemCheckPoint,
            mobileApplicationBannerBottom,
            nordicStringCheckPoint,
            nordicStrongButtonData,
            wellPopButtonData,
            wellPopCheckpoint,
            wearableAppBannerPoint,
            wearableAppFAQ,
            wearableAppMobileProcess,
            wearableAppServices,
            wearableAppTechnologyData,
            wearableAppUseCase,
            wearableChooseBody,
            wearableChooseContent,
            wearableDecodingData,
            wearableDeviceBuild,
            wearableEmergingData,
            wearableKeyFeature,
            wearablePricingData,
            onDemandIndustryData
        }
    };
};

const Banner = dynamic(() => import('@/components/Ui-components/Banner'));
const DisplayImage = dynamic(() => import('@/components/Ui-components/display-image'));
const Decoding = dynamic(() => import('@/components/Ui-components/Decoding'));
const auditImg = cdnImage('Wearable-App/Wearable-technology-market.webp');
const EndDevelopment = dynamic(() => import('@/components/Ui-components/EndDevelopmentService'));
const Platforms = dynamic(() => import('@/components/Ui-components/platforms'));
const LatestCTA = dynamic(() => import('@/components/Ui-components/LatestCta'));
const OurServices = dynamic(() => import('@/components/Ui-components/our-services'));
const OnDemandAdoption = dynamic(() => import('@/components/Ui-components/on-demand-adoption'));
const DynamicScreens = dynamic(() => import('@/components/Ui-components/Dynamic-screens'));
const nordicStrong = cdnImage('mobile-app-new-images/Nordic-strong.webp');
const tem = cdnImage('mobile-app-new-images/TEM.webp');
const wellPop = cdnImage('mobile-app-new-images/Wellpop.webp');
import Container from '@mui/material/Container';
const IndustryLeaders = dynamic(() => import('@/components/Ui-components/IndustryLeaders'));
const Pricing = dynamic(() => import('@/components/Ui-components/pricing'));
const CardTechnology = dynamic(() => import('@/components/Ui-components/card-technology'));
const MobileProcess = dynamic(() => import('@/components/Ui-components/MobileProcess'));
const development = cdnImage('Wearable-App/Wearable-App-Development-Workflow.svg');
const OurMakeChoice = dynamic(() => import('@/components/Ui-components/OurMakeChoice'));
const LetDiscuss = dynamic(() => import('@/components/Ui-components/Lets-discuss'));
const Testimonials = dynamic(() => import('@/components/Ui-components/Testimonials'));
const Questions = dynamic(() => import('@/components/Ui-components/questions'));
const HelperSection = dynamic(() => import('@/components/Ui-components/helper-section'));
import AggregateScript from '@/components/Common/Aggregate-script';
import {CDN_URL, SITE_URL} from '@/constants/urls';

const WearableAppDevelopment = (props: any) => {
    const {
        openForm,
        fitnessTemButtonData,
        fitnessTemCheckPoint,
        mobileApplicationBannerBottom,
        nordicStringCheckPoint,
        nordicStrongButtonData,
        wellPopButtonData,
        wellPopCheckpoint,
        wearableAppBannerPoint,
        wearableAppFAQ,
        wearableAppMobileProcess,
        wearableAppServices,
        wearableAppTechnologyData,
        wearableAppUseCase,
        wearableChooseBody,
        wearableChooseContent,
        wearableDecodingData,
        wearableDeviceBuild,
        wearableEmergingData,
        wearableKeyFeature,
        wearablePricingData,
        onDemandIndustryData
    } = props;
    return (
        <Box>
            <PageHead meta={WEARABLE_APP_DEVELOPMENT} url="/wearable-app-development" />
            <Banner
                priority={true}
                handleClickOpen={openForm}
                heading="Wearable App Development Company"
                subheading="Our wearable app development services are built to deliver real-time connectivity, cross-device performance, and industry-specific value. From smartwatches and fitness bands to AR/VR and medical wearables, we engineer scalable solutions that integrate seamlessly with your business workflows and end-user expectations—accelerating innovation while ensuring security, usability, and operational efficiency."
                button="Discuss Your Project Requirements"
                image={cdnImage('Wearable-App/wearable-app-development-Company.gif')}
                bannerClass="wearable-app-banner"
                // bannerBackground="new-home-banner-background"
                alt="Wearable App Development Company"
                DataPoints={wearableAppBannerPoint}
            />
            <Box className="sub-banner-wrapper sub-banner-bottom-wrapper">
                <MUIContainer>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between" className="white-label-bottom-container">
                        <Grid item md={2} lg={1.7} sm="auto" xs={12}>
                            <Typography className="banner-bottom-heading">Trusted By Leading Brands </Typography>
                        </Grid>
                        {mobileApplicationBannerBottom?.map((data: any, index: number) => (
                            <Grid item sm="auto" xs={6} className="sub-banner-images" key={index + 1}>
                                <Box className="images-banner-bottom">
                                    <DisplayImage src={data.src} alt={data.alt} priority={true} />
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </MUIContainer>
            </Box>
            <Grid item xs={12} className="bottom-margin top-space decording-main-wrapper mobile-top-padding mobile-bottom-margin">
                <MUIContainer>
                    <Decoding
                        imageSrc={auditImg}
                        alt="Ride wearable momentum to advance enterprise-wide digital transformation"
                        heading="Ride wearable momentum to advance enterprise-wide digital transformation"
                        subHeading={wearableDecodingData}
                        className=""
                        buttonText="Speak to Our Experts"
                        openForm={openForm}
                    />
                </MUIContainer>
            </Grid>
            <Box>
                <EndDevelopment
                    heading="Our Wearable App Development Services"
                    subheading="From concept to deployment, we offer end-to-end wearable app development services tailored to modern devices and real-world use cases. Our solutions combine usability, performance, and scalability—empowering businesses to launch, manage, and grow across the wearable technology landscape."
                    contentData={wearableAppServices}
                    openForm={openForm}
                    Cta="Drive Better Engagement with Smart Wearable Experiences"
                    robotImage={false}
                />
            </Box>
            <Grid item xs={12} className="blockchain-revolution-service bottom-spacing  mobile-bottom-padding top-space mobile-top-padding">
                <MUIContainer>
                    <Platforms
                        data={wearableDeviceBuild}
                        heading="Devices and Platforms We Build For"
                        subheading="From fitness trackers and smart rings to medical wearable development, we build apps that perform flawlessly across major platforms. Each solution is engineered for scalability, real-time connectivity, and smooth integration with your broader digital ecosystem."
                        containerClass="blockchain-card-container"
                        className="platform-key-industry-service no-border"
                    />
                </MUIContainer>
            </Grid>
            <Box className="bottom-spacing  mobile-bottom-padding ">
                <LatestCTA
                    heading="Need expert guidance on wearable software scalability?"
                    subheading="We’ve architected solutions used by 1M+ users. Let’s explore the right infrastructure and integrations for your wearable app."
                    buttonText="Talk to a Technical Consultant"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Grid item xs={12} className="helper-section">
                <Box className="helper_section_parent bottom-spacing top-space mobile-top-padding">
                    <Grid container spacing={2} className="our-service-defi-wrapper">
                        <OurServices
                            ourServices={wearableKeyFeature}
                            className="service-shadow-border-box enterprise-key-card"
                            containerClass="card-heading-spacing"
                            heading="Key Features We Integrate in Our Wearable App Development Solutions"
                            subheading="We build wearable apps with features that go beyond functionality—designed to deliver real-time intelligence, operational efficiency, and secure connectivity across devices. Each feature is thoughtfully integrated to align with your business requirements and user expectations."
                        />
                    </Grid>
                </Box>
            </Grid>
            <Box className="demand-adoption-section-wrapper bottom-spacing top-space mobile-top-padding mobile-bottom-padding">
                <OnDemandAdoption heading="Potential Use-Cases of Wearable Application Development " contentData={wearableAppUseCase} />
            </Box>
            <Box className="bottom-spacing  mobile-bottom-padding ">
                <LatestCTA
                    heading="Curious which wearable use-case fits your business?"
                    subheading="We’ve mapped 30+ real-world opportunities across industries. Let’s explore what’s feasible and profitable for your brand."
                    buttonText="Talk to Our Wearable Strategist"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Grid item xs={12} className="dynmaic-white-label-wrapper  bottom-margin dynamic-bep20-wrapper mobile-bottom-margin ">
                <MUIContainer>
                    <Box className="spectrum-header-wrapper solutions">
                        <Typography className="spectrum-heading color-black " component="h2">
                            Our Portfolio of Wearable App Solutions
                        </Typography>
                        <Box className="divder-wrapper">
                            <hr className="divider-line" />
                        </Box>
                        <Typography className="spectrum-sub-heading color-black text-align-left" component="p">
                            We take pride in building tailored, scalable wearable app development solutions that align with user behavior,
                            business goals, and device ecosystems. Explore how our team works with clients—from startups to global brands—to
                            bring wearable technology to life with precision, creativity, and results.
                        </Typography>
                    </Box>
                    <DynamicScreens
                        imageSrc={nordicStrong}
                        heading="Nordic Strong – The Next-Level Fitness Coaching App"
                        subPoints={[
                            'Debut Infotech collaborated with Nordic Strong to create a boutique fitness app offering structured workout programs, real-time performance tracking, and engaging virtual training experiences for users worldwide.'
                        ]}
                        reverseOrder={true}
                        alt="Nordic Strong"
                        checkItems={nordicStringCheckPoint}
                        buttonData={nordicStrongButtonData}
                        imageClass="dynamic-exchange-image"
                    />
                    <DynamicScreens
                        imageSrc={wellPop}
                        heading="An IoT-Powered Healthcare Innovation with WellPoP"
                        subPoints={[
                            'Debut Infotech developed WellPoP, an advanced healthcare management platform designed to address fragmentation in the healthcare sector. The system integrates IoT technology to track patient activities and enhance data-driven care management.'
                        ]}
                        reverseOrder={false}
                        alt="WellPoP"
                        checkItems={wellPopCheckpoint}
                        buttonData={wellPopButtonData}
                        // Only WellPoP has a case-study page; the other projects render without a CTA.
                        caseStudy={true}
                        openForm="/case-study/wellpop"
                        imageClass="dynamic-exchange-image"
                        buttonLabel="View Case Study"
                        buttonClass="helper-card-button"
                    />
                    <DynamicScreens
                        imageSrc={tem}
                        heading="Revolutionizing Fitness with TĒM"
                        subPoints={[
                            'Debut Infotech collaborated with TĒM to develop a comprehensive fitness app that offers personalized workout plans, diverse exercise routines, progress tracking, and a strong community-driven experience. By leveraging AI and real-time data analytics, the app empowers users to take control of their fitness journey.'
                        ]}
                        reverseOrder={true}
                        alt="TĒM"
                        checkItems={fitnessTemCheckPoint}
                        buttonData={fitnessTemButtonData}
                        imageClass="dynamic-exchange-image"
                    />
                </MUIContainer>
            </Grid>
            <Grid item xs={12} className="helper-section">
                <Box className="helper_section_parent bottom-spacing top-space mobile-top-padding mobile-bottom-padding">
                    <MUIContainer>
                        <Box className="spectrum-header-wrapper solutions">
                            <Typography className="spectrum-heading color-black our-service-main-heading text-align-left" component="h2">
                                How Emerging Technologies Amplify the Potential of Wearable Apps
                            </Typography>
                            <Box className="divder-wrapper">
                                <hr className="divider-line divider-line-left" />
                            </Box>
                            <Box className="sub-heading-box" pb={4}>
                                <Typography className="spectrum-sub-heading color-black spacing">
                                    Positioned as a forward-focused wearable app development company, we apply emerging technologies to
                                    elevate the purpose and performance of wearable solutions—enabling organizations to move faster, act
                                    smarter, and deliver meaningful experiences at scale.
                                </Typography>
                            </Box>
                        </Box>
                        <Grid container spacing={2}>
                            <HelperSection data={wearableEmergingData} className="home-helper-card" />
                        </Grid>
                    </MUIContainer>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box className="renowed-client-wrapper  bottom-spacing mobile-bottom-padding top-space mobile-top-padding">
                    <MUIContainer>
                        <IndustryLeaders
                            heading="Industries We Serve"
                            subheading="From digitally native startups to enterprise innovators, organizations across diverse industries are tapping into wearable technology to improve productivity, personalize user experiences, and unlock real-time insights. As a trusted wearable app development company, we offer custom-built solutions that support everything from health monitoring and logistics tracking to immersive training and on-the-go customer engagement."
                            data={onDemandIndustryData}
                            className="industry-leader-content-wrapper industry-leader-content-animation"
                            classNm="industry-leader-content-side-space"
                        />
                    </MUIContainer>
                </Box>
            </Grid>
            <Box className=" ">
                <LatestCTA
                    heading="Have questions about wearable app opportunities in your sector?"
                    subheading="We’ve got answers. Schedule a one-on-one consultation to map wearable tech to your business model."
                    buttonText="Discuss Your Industry Needs"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Grid item xs={12} className="bottom-spacing mobile-bottom-padding">
                <Container maxWidth="lg">
                    <Pricing
                        heading="Hire Wearable App Developers Through Flexible Engagement Models"
                        subheading="Whether you're launching a new wearable application, integrating advanced features, or optimizing device compatibility, our flexible hiring models make it easy to hire wearable app developers that align with your project timeline, scope, and budget."
                        pricingData={wearablePricingData}
                        className="remote-pricing-developer-card price-dot-net-card hire-pricing"
                        onClick={openForm}
                    />
                    <Box mt={2} className="prompt-pricing-button">
                        <MUIButton onClick={openForm} label="Book a Quick Dev Call" className="helper-card-button" />
                    </Box>
                </Container>
            </Grid>
            <Grid
                item
                xs={12}
                className="bottom-spacing generative-tech-wrapper mobile-bottom-padding top-space mobile-top-padding helper_section_parent"
            >
                <CardTechnology
                    heading="The Technology Behind Our Next-Gen Wearable App Development"
                    subheading="Our wearable app developers use robust, cross-compatible, and sensor-ready technologies to build high-performance wearable applications. With deep knowledge of each platform’s wearable development kit, we deliver apps that are energy-efficient, responsive, and seamlessly integrated with healthcare, fitness, AR/VR, and industrial devices."
                    data={wearableAppTechnologyData}
                />
            </Grid>
            <Box className="bottom-spacing process-mobile-bottom-padding top-space mobile-top-padding">
                <MUIContainer>
                    <Box className="spectrum-header-wrapper solutions">
                        <Typography className="spectrum-heading color-black text-align-left" component="h2">
                            Our Agile Workflow for Wearable App Development
                        </Typography>
                        <Box className="divder-wrapper">
                            <hr className="divider-line divider-line-left" />
                        </Box>
                        <Box className="sub-heading-box" pb={4}>
                            <Typography className="spectrum-sub-heading color-black spacing text-align-left" component="p">
                                Recognized as a dependable wearable app development company in USA, we combine iterative agile practices
                                with domain-specific strategy—ensuring rapid development, shorter feedback loops, and solutions that flex
                                with your market and technical demands.
                            </Typography>
                        </Box>
                    </Box>
                    <Box textAlign="center">
                        <DisplayImage
                            src={development}
                            alt="Our DeFi Staking Platform Development"
                            className="approach-main-img approach-web-img"
                        />
                    </Box>
                    <Box className="approach-main-img approach-mobile-img">
                        <MobileProcess mobileProcess={wearableAppMobileProcess} />
                    </Box>
                </MUIContainer>
            </Box>
            <OurMakeChoice
                heading="What Makes Debut Infotech"
                subheading="a Leading Wearable App Development Company? "
                body={wearableChooseBody}
                contentData={wearableChooseContent}
            />
            <Grid item xs={12}>
                <LetDiscuss
                    heading="Let’s Build What’s Next in Wearable Tech"
                    subheading="If you're ready to shape smarter interactions and deliver connected experiences, we’re the wearable app development company to make it happen."
                    btnLabel="Get a Free Strategy Call"
                    openForm={openForm}
                    className="white-label-sprill"
                />
            </Grid>
            <Grid item xs={12} className="question-parent margin top-space mobile-top-padding">
                <MUIContainer>
                    <Questions accordianData={wearableAppFAQ} subpart={true} />
                </MUIContainer>
            </Grid>
            <Grid item xs={12}>
                <Box className="top-space mobile-top-padding bg-blue-background">
                    <Testimonials heading="Our Clients Describe Us Best" />
                </Box>
            </Grid>
            <script
                type="application/ld+json"
                id="wearable-app-development"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'FAQPage',
                        mainEntity: [
                            {
                                '@type': 'Question',
                                name: 'What is wearable app development?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Wearable app development involves creating software applications specifically designed to operate on wearable devices such as smartwatches, fitness trackers, smart glasses, and other body-worn gadgets. These apps are optimized for limited screen sizes, real-time data processing, and seamless connectivity with smartphones or cloud platforms, providing users with immediate access to information and functionalities on the go.​'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How to create a wearable app?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `Creating a wearable app involves several key steps:
Define the app's purpose: Identify the problem it solves or the need it addresses.
Choose the target platform: Decide between platforms like Wear OS, watchOS, or proprietary systems.
Design the user interface (UI): Focus on simplicity and ease of use for small screens.
Develop the app: Use appropriate programming languages (e.g., Kotlin for Wear OS, Swift for watchOS).
Test thoroughly: Ensure functionality across devices and scenarios.
Deploy and monitor: Release the app and gather user feedback for continuous improvement.​
Engaging with experienced developers can streamline this process and ensure a high-quality product.`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How much does it cost to develop a wearable app?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'The cost to develop a wearable app generally ranges from $15,000 to $80,000. Key factors include number of platforms supported, data integration requirements, UI complexity, and performance optimization. We provide tailored quotes aligned with your business objectives, feature scope, and long-term scalability needs.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How much should I pay for app development?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `App development costs depend on the app's purpose, complexity, and desired platforms. For wearable apps, consider the following:​
Simple fitness tracking app: $10,000 – $25,000
Healthcare monitoring app with real-time data: $50,000 – $100,000
Enterprise-level app with multiple integrations: $100,000+`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How long does it take to develop a wearable app?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'A basic wearable app typically takes 4–6 weeks to develop, including UI/UX and testing. Complex solutions—especially those with real-time data sync, backend integration, or compliance—can take 12–16 weeks. We follow agile methodologies to deliver value quickly while minimizing iteration cycles.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Can a wearable app work without constant phone connectivity?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Yes. Many wearable apps are designed to function independently using edge computing or offline data storage. Once reconnected, the app syncs data with the paired smartphone or cloud platform—ideal for fitness, healthcare, and field-service apps requiring real-time functionality without active phone tethering.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Are wearable apps secure?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Yes, wearable apps can be highly secure when built with encryption, secure BLE pairing, and cloud-based access controls. Compliance with HIPAA, GDPR, or SOC2 ensures user data privacy. Regular penetration testing and secured APIs further enhance trust and regulatory readiness.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Can you upgrade or modernize an existing wearable app?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Yes. We offer full wearable app modernization services, including UI/UX redesign, SDK and API upgrades, performance tuning, and compatibility with new wearable devices or platforms. We also refactor legacy code, enhance data security, and integrate cloud support to improve scalability, maintainability, and user experience across evolving ecosystems.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Can we scale the app for multiple wearable platforms?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Absolutely. We build wearable apps compatible with Apple Watch, Wear OS, Fitbit, HoloLens, and custom hardware. Our cross-platform architecture ensures consistent UX, seamless data sync, and backend scalability—empowering your business to launch and scale efficiently across multiple wearable ecosystems and user segments.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Why should we choose your team over others?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'We offer proven experience in wearable app development, combining deep technical expertise with business alignment. Our team builds secure, scalable apps for startups to Fortune 500s—ensuring rapid deployment, real-time connectivity, regulatory compliance, and outcomes tailored to your growth, innovation, and user retention goals.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Can you sign our custom NDA or legal agreements?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: "Yes. We're flexible with NDAs and legal frameworks. Whether you require a standard NDA, MSA, or a customized agreement vetted by your legal team, we’re happy to accommodate and ensure your confidential information and ideas are protected from day one."
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Will I own the source code after the project is complete?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Yes. Once the final payment is made, you receive full ownership of the source code, design assets, documentation, and associated IP. We transfer all rights to you as part of the agreement, ensuring you have complete control over the product and its future use.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Who holds the IP rights to the wearable app?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'You do. Upon project completion and final settlement, full intellectual property rights for the app—including source code, architecture, and design—are transferred to your organization. We do not retain any licensing or reuse rights unless contractually agreed otherwise.'
                                }
                            }
                        ]
                    })
                }}
            />
            <AggregateScript
                name="Wearable App Development"
                image={`${CDN_URL}?url=%2Fimages%2FWearable-App%2Fwearable-app-development-Company.gif&w=750&q=75`}
                description="Our wearable app development services help you build smart, responsive, and user-friendly apps tailored for smartwatches, fitness trackers, and IoT wearables. We focus on seamless connectivity, real-time data sync, and intuitive UX across Android and iOS platforms."
                offers={{
                    '@type': 'AggregateOffer',
                    url: `${SITE_URL}/wearable-app-development`,
                    priceCurrency: 'USD',
                    lowPrice: '50000',
                    highPrice: '100000',
                    offerCount: '10'
                }}
                aggregateRating={{
                    '@type': 'AggregateRating',
                    ratingValue: '5',
                    bestRating: '5',
                    worstRating: '2',
                    ratingCount: '499'
                }}
            />
        </Box>
    );
};

export default WearableAppDevelopment;
WearableAppDevelopment.Layout = 'Main';
